import type { KeyValueStore, MatchFormatId } from '../core';
import { browserStore } from './loadoutStore';

const KEY = 'critter.format';

/** Preview experiments. `?dev=1` is the only way the quick format is offered. */
export function devMode(search?: string): boolean {
  const raw = search ?? (typeof window === 'undefined' ? '' : window.location.search);
  return new URLSearchParams(raw).get('dev') === '1';
}

/**
 * The duel to start. Without `?dev=1` this is always standard, even if a
 * quick choice was saved earlier.
 */
export function loadPlayFormat(store: KeyValueStore = browserStore, dev = devMode()): MatchFormatId {
  if (!dev) return 'standard';
  return store.getItem(KEY) === 'quick' ? 'quick' : 'standard';
}

export function savePlayFormat(id: 'standard' | 'quick', store: KeyValueStore = browserStore): void {
  store.setItem(KEY, id);
}
